// extracted by mini-css-extract-plugin
export var standaloneTable = "_1s-0";
export var standaloneTableWithBodyFill = "_1s-1";
export var withExtraHeader = "_1s-2";